import React from "react";
import ReactApexChart from "react-apexcharts";

interface DonutChartProps {
  labels: string[];
  series: number[];
  colors: string[];
  totalLabel?: string; // Optional label for the center total (defaults to "Total")
}

const DonutChart: React.FC<DonutChartProps> = ({ colors, labels, series, totalLabel = "Total" }) => {
  const total = series.reduce((a, b) => a + b, 0);
  
  // Value formatter for individual slices - receives the actual value
  const valueFormatter = (val: number) => {
    // val is the actual series value, not a percentage
    return val.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };
  
  const options: any = {
    chart: {
      type: "donut" as "donut",
      height: 350,
    },
    labels: labels,
    colors: colors,
    legend: {
      show: true,
      position: "right" as "right",
      fontSize: "14px",
      labels: {
        useSeriesColors: true,
      },
      formatter: function (seriesName: string, opts: any) {
        const count = series[opts.seriesIndex];
        const formattedCount = count.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        return `${seriesName} ${formattedCount}`;
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "16px",
              fontWeight: 600,
            },
            value: {
              show: true,
              fontSize: "20px",
              fontWeight: 700,
              formatter: valueFormatter,
            },
            total: {
              show: true,
              label: totalLabel,
              fontSize: "16px",
              fontWeight: 600,
              formatter: function () {
                return total.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
              },
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div id="donut-chart">
      <ReactApexChart options={options} series={series} type="donut" height={350} />
    </div>
  );
};

export default DonutChart;
